module.exports = __webpack_public_path__ + "img/wa_white.7adab758.png";